module.exports = __webpack_public_path__ + "static/media/kansei_dango.04a8d8d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kansei_dango.jpg
// module id = 317
// module chunks = 0